import {AlertsConfig} from "cartovistaExtend/appTools/AlertsConfig";
import "styles/Alerts.css";
import { Toast } from 'bootstrap';

var html = '<div aria-live="polite" aria-atomic="true" class="position-relative">' +
              '<div class="toast-container top-0 end-0 p-3"></div>'+
            '</div>';
$(".cv-left-top-pane").append(html);

    export function show(alertId, alertParams) {
        var alertHtml = get(alertId, alertParams);
        $(".toast-container").append(alertHtml);
        _.forEach($(".toast-container").find("#" + alertId), function(toast){
          new Toast(toast).show();
          toast.addEventListener('hidden.bs.toast', () => {
            $(toast).remove();
          }, {once : true});
        });
    };

    export function get(alertId, alertParams) {
        var alertConfig = _.cloneDeep(AlertsConfig[alertId]);
        if (typeof alertConfig != "undefined") {
            alertConfig.options.icon = _getAlertIcon(alertConfig);
            alertConfig.options.message = _getAlertMessage(alertConfig, alertParams);
            if (alertConfig.options.date != false && typeof alertConfig.options.title == "undefined") {
                alertConfig.options.title = new Date().toLocaleString("fr");
            }
            return '<div id="' + alertId + '" class="' + ["toast", "align-items-center", "border-0", "text-bg-" + alertConfig.settings.type].concat(alertConfig.options.classes).join(" ") + '" role="alert" aria-live="assertive" aria-atomic="true">'+
                      '<div class="toast-header">'+
                        '<strong class="me-auto"><i class="bi ' + alertConfig.options.icon + '"></i></strong>' +
                        (alertConfig.options.title ? '<small>' + alertConfig.options.title + '</small>' : '') +
                        (alertConfig.settings.allow_dismiss ? '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>' : '') +
                      '</div>' +
                      '<div class="toast-body">' + alertConfig.options.message + '</div>' +
                    '</div>';
        } else {
            console.warn("Alerts._get() - Alerts._alertsConfigs[\"" + alertId + "\"] is undefined.");
        }
    };

    function _getAlertIcon(alertConfig) {
        switch (alertConfig.settings.type) {
            case "success":
                return "bi-check-circle";
            case "danger":
              return "bi-exclamation-circle";
            case "warning":
                return "bi-question-circle";
            case "info":
                return "bi-info-circle";
            default:
                console.warn("Alerts._getAlertIcon() - alertConfig.settings.type: " + alertConfig.settings.type + " is not handled.");
        };
    };

    function _getAlertMessage(alertConfig, alertParams) {
        var message = alertConfig.options.message;
        _.forEach(alertParams, function(param, key) {
            message = message.replace("{{" + key + "}}", param);
        });
        return message;
    };
